import { useState, useMemo } from 'react';
import { useRoleplayStore } from 'features/roleplay/Roleplay.store';
import RoleplayRating from '../Common/RoleplayRating/RoleplayRating';
import styles from './RoleplayView.module.scss';
import { Tooltip, Collapse, withStyles } from '@material-ui/core';
import AIFeedback from 'shared_ui_components/AIFeatures/AIFeedback/AIFeedback';
import { HelpOutline } from '@material-ui/icons';
import RatingCriteriaTooltip from '../Common/RatingCriteriaTooltip';
import classNames from 'classnames';

const ViewDescriptionRetakeOption = () => {
  const [showDetails, setShowDetails] = useState(false);
  const { scenarioSelected } = useRoleplayStore();

  const TooltipStyled = withStyles(() => ({
    tooltip: {
      backgroundColor: 'black',
      color: 'white',
    },
    arrow: {
      color: 'black',
    },
  }))(Tooltip);

  const StyledCollapse = withStyles({
    root: {
      border: showDetails ? '1px solid #CFD8DC' : null,
      borderRadius: showDetails ? '0.5rem' : null,
      padding: showDetails ? '5px 12px 14px 12px' : null,
      display: showDetails ? 'flex' : null,
      flexDirection: showDetails ? 'column' : null,
      gap: showDetails ? '1rem' : null,
    },
  })(Collapse);

  const areSuggestionsNull = useMemo(() => {
    return scenarioSelected?.response?.rating_criterials.every(
      ({ reasoning, improvement_suggestion }) =>
        reasoning === null && improvement_suggestion === null
    );
  }, [scenarioSelected]);

  const closeShowDetails = () => setShowDetails(false);
  const openShowDetails = () => setShowDetails(true);

  return (
    <div>
      {!areSuggestionsNull ? (
        <div className={styles.headContainer}>
          <RatingCriteriaTooltip />
          {showDetails ? (
            <div className={styles.action} onClick={closeShowDetails}>
              Hide details
            </div>
          ) : (
            <div className={styles.action} onClick={openShowDetails}>
              Show details
            </div>
          )}
        </div>
      ) : (
        <RatingCriteriaTooltip />
      )}
      {scenarioSelected?.response?.ai_raiting === false ? (
        <>
          {scenarioSelected?.response?.rating_criterials?.map(
            ({ rating_criteria, stars }, index) => (
              <div key={index} className={styles.rating}>
                <span>{rating_criteria?.name}</span>
                <RoleplayRating withTooltip stars={stars} />
              </div>
            )
          )}
          <div style={{ marginTop: '1rem' }}>
            Feedback
            <div className={styles.feedback}>{scenarioSelected?.response?.comment}</div>
          </div>
        </>
      ) : (
        <>
          <div>
            <div className={classNames({ [styles.globalContainer]: showDetails })}>
              {scenarioSelected?.response?.rating_criterials?.map(
                ({ rating_criteria, stars, reasoning, improvement_suggestion }, index) => (
                  <StyledCollapse in={showDetails} collapsedSize={25} key={index}>
                    <div className={styles.rating}>
                      <span>{rating_criteria?.name}</span>
                      <RoleplayRating withTooltip stars={stars} />
                    </div>
                    <div>
                      <p className="heading7Bold" style={{ marginTop: '0.25rem' }}>
                        Why this rating?
                      </p>
                      <p className="heading7" style={{ marginTop: '0.25rem' }}>
                        {reasoning}
                      </p>
                    </div>
                    <div>
                      <p className="heading7Bold" style={{ marginTop: '0.25rem' }}>
                        How to improve?
                      </p>
                      <p className="heading7" style={{ marginTop: '0.25rem' }}>
                        {improvement_suggestion}
                      </p>
                    </div>
                  </StyledCollapse>
                )
              )}
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <div className={styles.container}>
              <div>Feedback</div>
              <TooltipStyled
                title="Rating and feedback has been generated by AI."
                arrow
                placement="top"
              >
                <HelpOutline style={{ fontSize: '1rem' }} />
              </TooltipStyled>
            </div>
            <AIFeedback
              ai_feedback={scenarioSelected?.response?.comment}
              ai_feedback_status={'SUCCEEDED'}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default ViewDescriptionRetakeOption;
